import { Eye, Users, User } from '@phosphor-icons/react';
import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form } from 'reactstrap';
import { getAgeingModalAction, loaderAction } from '../../redux/actions/Index';
import Table from '../Table';
import EmptyTable from '../errorComponents/EmptyTable';
import axios from 'axios';
import { environment } from '../../env';
import moment from 'moment';

const SoldGalaGroupModal = (props) => {

  const soldGalas = useSelector((state) => state?.ModalReducer?.soldGalaList);
  const [Sgalas, setSGalas] = useState([]);

  const toggle = () => {
    props.tog(false)
  };

  const getGalas = () => {
    let galas = soldGalas?.filter(data => data.group_id == props.groupId)
    setSGalas(galas)
  }

  const ordinal = (i) => {
    var j = i % 10,
      k = i % 100;
    if (j == 1 && k != 11) {
      return i + "st";
    }
    if (j == 2 && k != 12) {
      return i + "nd";
    }
    if (j == 3 && k != 13) {
      return i + "rd";
    }
    return i + "th";
  }

  const columns = [
    {
      name: 'Status',
      selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
        <label className={`${row.ownership === 1 && 'icon-bg-green icon-color-green '} ${row.ownership === 2 && 'icon-bg-yellow icon-color-yellow'} ${row.ownership == 3 && 'status-bg-blue status-color-blue'} ${row.ownership >= 4 && 'bg-info text-white'}   rounded-pill status-box rounded fs-4`}>{`${ordinal(row.ownership)} Owner`}</label>
      </div>,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Owner Type',
      selector: row => <div className="d-flex justify-content-between align-items-center gap-3 " >
        <span>{row?.ownertype == "Self" ? <User size="26" className='text-base-red' /> : row?.ownertype == "Joined" && <Users size="26" className='status-color-blue' />}</span>
        <label className='fs-3'>{row?.ownertype}</label>
      </div >,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Party Name',
      selector: row => row.Investors?.name,
      sortable: true,
      wrap:true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Created On',
      selector: row => moment(row.created_at).format('DD/MM/YYYY'),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Building No',
      selector: row => row.building?.building_no,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },

    {
      name: 'Gala No',
      selector: row => Number(row.gala?.gala_no),
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    }, {
      name: 'Sub Gala',
      selector: row => row.sub_gala_name,
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    {
      name: 'Area',
      selector: row => (row.sold_gala_area - row.resell_area) + " " + "Sq.ft",
      sortable: true,
      style: {
        fontSize: "2.3rem",
      }
    },
    // {
    //   name: 'Upload',
    //   cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
    //     <DocUploadModal type={"soldgala"} soldGalaId={row?.id} />
    //   </div>,
    // },
    // {
    //   name: 'Action',
    //   cell: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
    //     <Link to={`/SoldGalas/${row.id}`} className="icon-bg-green border-0 px-2 py-3 rounded"><Eye size="28" className='icon-color-green' /></Link>
    //   </div>,
    // },
  ];

  useMemo(() => {
    getGalas()
  }, [props.groupId])

  return (
    <>
      {/* <button onClick={toggle} className="icon-bg-green border-0 p-3 py-3 rounded"><Eye size="26" className='icon-color-green'/></button> */}
      <Modal className='border-5' isOpen={props.toggle} toggle={toggle} size="xl" centered>
        <ModalHeader className='bg-base-color ' toggle={toggle} >
          <div className="d-flex justify-content-around ">
            <h1 className='title-font-bold text-base-white'>Joined Partners</h1>
          </div>
        </ModalHeader>
        <ModalBody className='bg-white p-2 d-flex justify-content-center flex-column'>
          <div className="bg-white p-5 rounded-5  shadow-sm">
            {Sgalas?.length != 0 ? <Table columns={columns} data={Sgalas} /> : <EmptyTable />}
          </div>
        </ModalBody>
      </Modal>
    </>
  )
};


export default SoldGalaGroupModal